import React, { useState, useRef, useEffect } from 'react';
import './index.css'

const BuyExtraStorageModal = ({ isOpen, onClose, onSubmit }) => {
  const [storage, setStorage] = useState(0)
  const [error, setError] = useState('');
  const modalRef = useRef(null);

  const closeHandler = () => {
    onClose();
    setStorage(0);
    setError('');
  };


  const handleSubmit = (type:string) => {
    if (storage < 1) {
      setError('Minimum storage top-up is 1 GB.');
      return;
    } else if (storage > 100000) {
      setError('Maximum storage top-up is 100000 GB.');
      return;
    }

    onSubmit(storage,type);
    setStorage(0);
    setError('');
    closeHandler();
  };

  // Handle outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        closeHandler();
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 9999,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '1rem',
        backgroundColor: 'rgba(0, 0, 0, 0.4)',
        backdropFilter: 'blur(4px)',
        WebkitBackdropFilter: 'blur(4px)',
      }}
    >
      <div
        ref={modalRef}
        className="bg-white w-full max-w-lg rounded-2xl shadow-xl p-6 relative"
      >
        {/* Header */}
        <div className="flex justify-between items-center mb-5">
          <h2 className="text-2xl text-center font-bold text-gray-900">
            Extra Storage Required
          </h2>
          <button
            onClick={closeHandler}
            className="text-gray-600 hover:text-red-500 text-2xl"
          >
            &times;
          </button>
        </div>

        {/* Storage Display */}
        <div className="!border-2 !border-teal-600 rounded-lg p-4 flex items-center text-3xl font-bold text-teal-600 mb-4">
          {/* Left Icon */}
          <span className="inline-flex items-center mr-3">
            <div className="w-10 h-10 bg-teal-600 rounded-3xl mr-1 flex items-center justify-center">
                <span className="text-white font-bold" style={{ fontSize: '18px' }}>GB</span>
            </div>
            <span className="w-[2px] h-14 bg-teal-600"></span>
          </span>

          {/* Middle: Editable Storage amount */}
          <input
            type="number"
            value={storage}
            onChange={(e) => {
              const val = parseInt(e.target.value, 10);
              if (isNaN(val)) {
                setStorage(0);
              } else {
                setStorage(val);
              }
              setError('');
            }}
            className="flex-1 text-3xl font-bold text-teal-600 bg-transparent outline-none text-start border-none w-[90%] [appearance:textfield] [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none"
          />

          {/* Rightmost: Clear button */}
          {storage > 0 && (
            <button
              onClick={() => {
                setStorage(0);
                setError('');
              }}
              className="text-teal-600 hover:text-red-600 text-3xl leading-none ml-4"
              title="Clear"
            >
              &times;
            </button>
          )}
        </div>


        {/* Error Message */}
        {error && (
          <div className="text-red-600 text-sm mb-4">{error}</div>
        )}

        {/* Footer */}
        <div className="flex justify-end gap-3">
          <button
            style={{borderRadius: "50px"}}
            onClick={closeHandler}
            className="px-4 py-2 text-gray-600 hover:text-red-500 rounded-lg transition text-md !border-2 !border-black bg-white shadow"
          >
            Cancel
          </button>
          <button
            style={{borderRadius: "50px"}}
            onClick={() => handleSubmit('cash')}
            className="px-5 py-2 bg-teal-600 text-white rounded-lg font-medium hover:bg-teal-700 transition text-md"
          >
            Pay Manually
          </button>
          <button
            style={{borderRadius: "50px"}}
            onClick={() => handleSubmit('credit')}
            className="px-5 py-2 bg-teal-600 text-white rounded-lg font-medium hover:bg-teal-700 transition text-md"
          >
            Pay with Credits
          </button>
        </div>
      </div>
    </div>
  );
};

export default BuyExtraStorageModal;
